import {Route } from 'react-router-dom';
import Login from '../Components/Stateless/Login';
import ForgotPassword from '../Components/Stateless/ForgotPassword';
import ResetPassword from '../Components/Stateless/ResetPassword';
import SetNewPassword from '../Components/Stateless/SetNewPassword';

const PublicRoutes = () => {
  return (
    <>
      <Route path="/" element={<Login />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/set-new-password" element={<SetNewPassword />} />
    </>
  );
};

export default PublicRoutes;
